import React, {useState, useEffect} from "react";
import RjsProductList from "../../../react-components/RjsProductList";
import useProductsFetcher from "../useProductsFetcher";

// This list retrieves "bought together" products from the order's line_items.
const PDPBoughtTogetherList = (props) => {
  const defaultLimitTo = 8;
  const {product} = props;
  const {limitTo = defaultLimitTo} = props;
  const [products, setProducts] = useState([]);

  const {loadArbitrarySet} = useProductsFetcher();

  const fetchTrends = () => {
    loadArbitrarySet({
      namedSet: "bought_together",
      limitTo,
      product_id: product?.id,
      sort_mode: "popularity"
    }).then(result => {
      setProducts(result);
    });
  };

  useEffect(() => {
    if (!products?.length && product?.id) {
      fetchTrends();
    }
  }, [product]);

  return <>
    {products.length > 0 &&
      <RjsProductList
        products={products}
        hideMoreButton={true}
        {...props}
      />
    }
  </>;
};

export default PDPBoughtTogetherList;
